import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-2" }
const _hoisted_2 = { class: "flex md:flex-row flex-col w-full md:items-center mb-8" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "mb-0 ml-2 mr-auto" }
const _hoisted_5 = { class: "flex h-64 space-x-8 mb-2" }
const _hoisted_6 = { class: "w-2/3 mb-auto flex flex-col" }
const _hoisted_7 = { class: "text-muted mb-8" }
const _hoisted_8 = { class: "flex items-start space-x-2 mb-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons text-muted mt-1.5" }, "link", -1)
const _hoisted_10 = { class: "w-full" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/3 flex" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_SegmentedControls = _resolveComponent("SegmentedControls")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_ArticleHandle = _resolveComponent("ArticleHandle")!
  const _component_TextInput = _resolveComponent("TextInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Btn, {
          variant: 'icon',
          outline: true,
          class: "-ml-2"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: "material-icons-outlined",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeEditor')))
            }, " close")
          ]),
          _: 1
        }),
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("course_tree.file_editor_title")), 1)
      ]),
      _createVNode(_component_Dropdown, {
        class: "md:w-1/3 w-2/3 ml-auto md:mt-0 md:-mb-0 mt-2 -mb-4",
        loading: _ctx.loadingTopics,
        options: _ctx.topicsAsOptions,
        modelValue: _ctx.modelValue.parent_id,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.onParentChange($event)))
      }, null, 8, ["loading", "options", "modelValue"])
    ]),
    false
      ? (_openBlock(), _createBlock(_component_SegmentedControls, {
          key: 0,
          class: "mb-10",
          options: _ctx.panes,
          modelValue: _ctx.currentPane,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentPane) = $event))
        }, null, 8, ["options", "modelValue"]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_component_FileUpload, {
        uploadProgress: _ctx.uploadProgress,
        uploading: _ctx.blockingSaving,
        showMaxSize: true,
        modelValue: _ctx.fileProxy,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.fileProxy) = $event))
      }, null, 8, ["uploadProgress", "uploading", "modelValue"])
    ], 512), [
      [_vShow, _ctx.currentPane === 'file_upload']
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, [
            _createTextVNode(_toDisplayString(_ctx.$t("course_tree.file_by_url_description")) + " ", 1),
            _createVNode(_component_ArticleHandle),
            _createTextVNode(". ")
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_TextInput, {
                class: "w-full",
                placeholder: _ctx.$t('course_tree.file_url')
              }, null, 8, ["placeholder"]),
              _createVNode(_component_Btn, { class: "mt-2" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("misc.save")), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _hoisted_11
      ])
    ], 512), [
      [_vShow, _ctx.currentPane === 'url']
    ])
  ]))
}